import React from 'react';
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import css from './DishSemiFinishedList.module.css';
import DishSemiFinish from "../DishSemiFinish/DishSemiFinish";


const DishSemiFinishedList = () => {
    const {t} = useTranslation();
    const {dishSemiFinishedModalArray} = useSelector(store => store.dishSemiFinished);


    return (
        <section className={css.wrap}>
            {dishSemiFinishedModalArray.length > 0 ? (
                dishSemiFinishedModalArray.map((obj, index) => <DishSemiFinish
                    key={obj.id}
                    dishSemiFinish={obj}
                    index={index}
                />)
            ) : <div className={css.noData}>{t('no-data')}</div>}
        </section>
    );
};

export default React.memo(DishSemiFinishedList);